"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importStar(require("react"));

var styled_1 = require("./styled");

var OTPInput = function OTPInput(_a) {
  var length = _a.length,
      onComplete = _a.onComplete,
      className = _a.className,
      suffix = _a.suffix,
      errMsg = _a.errMsg;

  var _b = react_1.useState(''),
      otp = _b[0],
      setOTP = _b[1];

  var handleOnInputChange = react_1.useCallback(function (e) {
    var input = e.target.value;

    if (input.match(/^[0-9]*$/) && input.length <= length) {
      setOTP(input);
    }

    if (input.length === length) {
      onComplete(input);
    }
  }, []);
  return react_1.default.createElement(styled_1.OTPInputContainer, {
    className: className
  }, react_1.default.createElement(styled_1.OTPInputField, {
    suffix: suffix,
    errMsg: errMsg,
    errMsgPosition: "center",
    inputMode: "numeric",
    autoComplete: "one-time-code",
    onChange: handleOnInputChange,
    value: otp,
    placeholder: "\u0E23\u0E2B\u0E31\u0E2A " + length + " \u0E2B\u0E25\u0E31\u0E01"
  }));
};

OTPInput.defaultProps = {
  length: 4
};
exports.default = OTPInput;